import Vue from 'vue'
import Vuex from 'vuex'
import auth from './Auth'
import error from './Error'
import loader from './Loader'
import modal from './Modal'
import comparison from './Comparison'
import demand from './Demand'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        auth,
        error,
        loader,
        modal,
        comparison,
        demand,
    },
    plugins: [
        createPersistedState({
            key: 'anyGreatApp',
            paths: [
                'comparison',
            ],
            storage: window.sessionStorage
        }),
        createPersistedState({
            key: 'stateDemand',
            paths: [
                'demand',
            ],
            storage: window.sessionStorage
        }),
    ],
})

export default store